import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { HistorialCambios } from '../../../core/model/inventories';
import { Page } from '../../../core/model/page';
import { Userprofile } from '../../../core/model/users';
import { UsersService } from '../../../core/services/users.service';

@Component({
  selector: 'app-historial-cambios',
  templateUrl: './historial-cambios.component.html',
  styleUrls: ['./historial-cambios.component.css']
})
export class HistorialCambiosComponent implements OnInit {

  @ViewChild('tableRequestChange') table: any;

  private _historialCambios: HistorialCambios[] = [];
  @Input()
  set historialCambios(historial: HistorialCambios[]) {
    this._historialCambios = historial;
    if (this._historialCambios) {
      for (let cambio of this._historialCambios) {
        this.userService.getUserById(cambio.usuarioId).pipe(first())
          .subscribe((user: Userprofile) => cambio.nombreUsuario = `${user.NOMBRE} ${user.APELLIDOS}`);
      }
    }
  }
  get historialCambios(): HistorialCambios[] {
    return this._historialCambios;
  }

  @Input() expedienteId: number;

  @Input() set isInAccessChangesHistoric(isInAccessChangesHistoric: boolean) {
    this.isLoadingData = true;
    this.page.totalElements = this.historialCambios.length;
    this.isLoadingData = false;
  }

  isLoadingData: boolean;

  page = new Page();

  // ngx-datatable options
  customMessages = {
    emptyMessage: 'No hay usuarios disponibles',
    totalMessage: 'Total',
    selectedMessage: 'Selección'
  };
  customClasses = {
    sortAscending: 'fas fa-sort-up',
    sortDescending: 'fas fa-sort-down',
    pagerLeftArrow: 'fas fa-chevron-left',
    pagerRightArrow: 'fas fa-chevron-right',
    pagerPrevious: 'fas fa-step-backward',
    pagerNext: 'fas fa-step-forward'
  };

  constructor(
    private router: Router,
    private userService: UsersService
  ) {
    this.page.pageNumber = 0;
    this.page.size = 10;
  }

  ngOnInit() {
  }

  onResizedTable(event: any): void {
    if (this.table) {
      setTimeout(() => {
        this.table.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  viewDetail(identificador: string) {
    this.router.navigate(['docout', { outlets: { contenido: ['detalle', identificador] } }]);
  }

}
